// extracted by mini-css-extract-plugin
module.exports = {"chatRoom":"ChatRoom_chatRoom__oIDih","scrollTo":"ChatRoom_scrollTo__3E6YW","loadingMessageContainer":"ChatRoom_loadingMessageContainer__2mwbZ"};